import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { ProductListReviewItem, ProductListReviewsCollection } from '@reviews/const';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as ReviewsActions from '../store/actions/reviews.action';
import { StateWithReviews } from '../store/reviews-state';
import * as ReviewsSelectors from '../store/selectors/reviews.selectors';

@Injectable({
  providedIn: 'root',
})
export class ProductListReviewsService {
  constructor(private store: Store<StateWithReviews>) {}

  loadReviews(productCodes: string[]): void {
    this.store.dispatch(new ReviewsActions.LoadProductListReview(productCodes));
  }

  getReviews(productCode: string): Observable<ProductListReviewItem | undefined> {
    return this.store.pipe(
      select(ReviewsSelectors.getProductListReviewValue),
      map((reviews: ProductListReviewsCollection) => reviews?.[productCode] || undefined),
    );
  }

  getReviewsCollection(): Observable<ProductListReviewsCollection | undefined> {
    return this.store.pipe(select(ReviewsSelectors.getProductListReviewValue));
  }
}
